import styled from 'styled-components';

const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 999px;
  background: #FF9800;
  color: ${p => p.theme.palette.common.white};
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
`;

export const DiscountChip: React.FC<{
  label: string;
}> = ({ label }) => (
  <Chip>{label}</Chip>
);

export default DiscountChip;
